<div class="warp-tow-popup">
  <div class="popup">
    <div class="header">
      <img src="/assets/images/popup-recipient/people-icon.svg" />
      <div>
        <p translate *ngIf="isCreate" class="share-title">newDistributionGroup.create</p>
        <p translate *ngIf="!isCreate" class="share-title">newDistributionGroup.update</p>
      </div>
    </div>
    <div class="wrapper">
      <div class="color">
        <que-distribution-group-square [name]="groupName.value!" [color]="color.value!"></que-distribution-group-square>
        <div class="warp-color" (click)="colorInput.click()">
          <img src="/assets/images/popup-recipient/colors.svg" />
          <input #colorInput calss="colorInput" type="color" [formControl]="color" />
        </div>
      </div>
      <div class="input">
        <p class="label" translate>newDistributionGroup.name</p>
        <input class="select name" type="text" placeholder="{{'newDistributionGroup.name' | translate}}" matInput
          [formControl]="groupName" />
      </div>
    </div>
    <div class="input group-type">
      <p class="label" translate>newDistributionGroup.groupType</p>
      <mat-select class="select" [formControl]="groupType">
        <mat-option *ngFor="let gt of groupTypes$()" [value]="gt.id">{{gt.name}}</mat-option>
      </mat-select>
    </div>
    <p class="label" translate>newDistributionGroup.addPeople</p>
    <div class="warp-select">
      <que-select-users-input [canDelete]="true" [isJustUserInput]="true"></que-select-users-input>
    </div>
    <p class="label t" translate *ngIf="isRecipients$()">
      newDistributionGroup.peopleInGroup
    </p>
    <div class="contacts">
      <div *ngIf="recipients$ | async as recipient">
        <que-contact-display *ngFor="let r of recipients$ | async, let i= index"
          [contact]="r.user"></que-contact-display>
      </div>
    </div>
    <div class="footer">
      <div></div>
      <div class="btns">
        <div class="btn next pointer" (click)="cancel()">
          <p translate>btns.cancelPublish</p>
        </div>

        <div class="btn next pointer blue" (click)="isRecipients$()?save():null"
          [ngClass]="{'disabled':!isRecipients$() || groupName.invalid}">
          <p *ngIf="!isCreate" translate>btns.save</p>
          <p *ngIf="isCreate" translate>btns.create</p>
        </div>
      </div>
    </div>

  </div>
</div>